import { render, staticRenderFns } from "./LCDSettings.vue?vue&type=template&id=8c76f792"
import script from "./LCDSettings.vue?vue&type=script&lang=js"
export * from "./LCDSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports